import { mdiTrendingUp } from "@mdi/js";

const gTrends = [
  {
    title: "Google Trends",
    icon: mdiTrendingUp,
    children: [
      {
        title: "Suivi des Tendances",
        to: "gTrendsIndex",
        resource: "gtrends",
        action: "manage",
      },
      {
        title: "Notifications",
        to: "gTrendsNotifications",
        resource: "gtrends",
        action: "manage",
      },
    ],
  },
];

export default gTrends;
